import React, {Component} from 'react';
import HelpRequestTableHeader from './components/HelpRequestTableHeader';
import HelpRequestTableRow from './components/HelpRequestTableRow';
import AdminHead from '../../Admin/components/AdminHead.js'
import callApi from "../../../util/apiCaller";
import {showNotification} from "../../../util/utility";
import {Button, Modal} from "react-bootstrap";
import _ from 'lodash';

class EmailTemplateList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emailtemplates: [],
            pageNum: 1,
            pageSize: 200,
            totalCount: 0,
            qtext: '',
            editItem: {}
        }
    }

    componentDidMount() {
        this.fetchItems();
    }


    fetchItems = () => {
        let filters = this.getFilters();
        callApi(`emailtemplates/list`, "post", filters).then((res) => {
            if (res.status === 'Success') {
                this.setState({
                    emailtemplates: res.data.emailtemplates,
                    totalCount: res.data.totalCount
                })
            } else {
                showNotification("error", "Some error occured");
            }
        });
    }

    getFilters = () => {
        let filters = {};
        filters.pageNum = this.state.pageNum;
        filters.pageSize = this.state.pageSize;
        return filters;
    };

    handleApplyFilters = () => {
        this.fetchItems();
    };

    handleSearchFilter = (obj) => {
        let searchObj ={};
        searchObj[this.keyStateObjNameDict[obj.keyName]]=obj
        this.setState(searchObj, () => {
            this.handleApplyFilters();
        })
    };

    inputSelectorHandler = (obj) =>{
        let selectorObj ={};
        selectorObj[this.keyStateObjNameDict[obj.keyName]]=obj
        this.setState(
            selectorObj,() => {
            this.handleApplyFilters();
        })
    }

    handleChange = (keyname, keyvalue) => {
        let editItem = this.state.editItem;
        editItem[keyname] = keyvalue;
        this.setState({
            editItem: editItem
        })
    };

    saveTemplate = () => {
        let editItem = this.state.editItem;
        this.setState({
            isSaving: true
        });
        callApi(`emailtemplates/${editItem._id}/data-update`, "post", {
            emailtemplate : editItem
        }).then((res) => {
            this.setState({
                isSaving: false
            });
            if (res.status === 'Success') {
                showNotification("success", "Template Updated");
            } else {
                showNotification("error", "Some error occured");
            }
        });
    };

    toggleEditItem = (editItem) => {
        this.setState({
            editItem: editItem
        })
    };

    handleClose = () => {
        this.toggleEditItem({});
    }

    preview = (html) => {
        let  win =window.open(" ",'scrollbars=1');
        win.document.write("<div id ='popup'>"+html+"</div>");
    }

    render() {
        return (
            <div className="row" style={{width:'100%'}}>
                <AdminHead/>
                <section id="admin-company" class="col">
                    <div className="request-data-table tableFixHead">
                        <table className="table team">
                            <HelpRequestTableHeader
                                searchObjContactName = {this.state.searchObjContactName}
                                searchObjIssueDesc = {this.state.searchObjIssueDesc}
                                selectorObjIssueType = {this.state.selectorObjIssueType}
                                inputSelectorHandler = {this.inputSelectorHandler}
                                handleSearchFilter = {this.handleSearchFilter}
                            />
                            <tbody className="team-body">
                            {this.state.emailtemplates && this.state.emailtemplates.map(item => (
                                <HelpRequestTableRow
                                    item={item}
                                    toggleEditItem={this.toggleEditItem}
                                />
                            ))}
                            </tbody>
                        </table>
                    </div>
                </section>
                {!_.isEmpty(this.state.editItem) ?
                    <Modal
                        show={!_.isEmpty(this.state.editItem)}
                        onHide={this.handleClose}
                        size='lg'
                        aria-labelledby='contained-modal-title-vcenter'
                        centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Edit Template</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div>
                               <div className="row">
                                   <input
                                       type={'text'}
                                       value={this.state.editItem.templateSubject}
                                       onChange={(e) => this.handleChange('templateSubject', e.target.value)}
                                   />
                               </div>
                                <div className="row">
                                   <input
                                       type={'text'}
                                       value={this.state.editItem.code}
                                       onChange={(e) => this.handleChange('code', e.target.value)}
                                   />
                               </div>
                                <div className="row">
                                    <textarea
                                        value={this.state.editItem.templateBody}
                                        rows='10'
                                        cols='50'
                                        style={{}}
                                        onChange={(e) => this.handleChange('templateBody', e.target.value)}
                                    />
                                </div>
                            </div>
                        </Modal.Body>

                        <Modal.Footer>
                            <Button variant='secondary' onClick={() => this.handleClose()}>
                                Close
                            </Button>
                            <Button
                                variant='primary'
                                disabled={this.state.isSaving}
                                onClick={() => this.saveTemplate()}>
                                {this.state.isSaving ? "Saving" : "Save"}
                            </Button>
                            <Button
                                variant='primary'
                                onClick={() => this.preview(this.state.editItem.templateBody)}>
                               <i class="fa fa-eye" aria-hidden="true"></i> Preview
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    :
                    null
                }
            </div>
        );
    }
}

export default EmailTemplateList;
